import { DefaultFooter } from '@ant-design/pro-components'
import React from 'react'

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright='版权所有：江西百炼供应链管理有限公司 赣ICP备2025073276号-1'
    />
  )
}

export default Footer
